import { IconProps } from 'assets'

const PrecisionManufacturing = ({ className, pathClassName = 'fill-[#955CF6]' }: IconProps): JSX.Element => {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_8976_222372"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18">
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8976_222372)">
        <path
          className={pathClassName}
          d="M2.98145 15.7505V13.5005H5.30645L3.39395 7.23801C3.05645 7.05051 2.77832 6.77551 2.55957 6.41301C2.34082 6.05051 2.23145 5.66301 2.23145 5.25051C2.23145 4.62551 2.4502 4.09426 2.8877 3.65676C3.3252 3.21926 3.85645 3.00051 4.48145 3.00051C4.96895 3.00051 5.40332 3.14113 5.78457 3.42238C6.16582 3.70363 6.43145 4.06301 6.58145 4.50051H8.98145V3.75051C8.98145 3.53801 9.05332 3.35988 9.19707 3.21613C9.34082 3.07238 9.51895 3.00051 9.73145 3.00051C9.84395 3.00051 9.95332 3.02551 10.0596 3.07551C10.1658 3.12551 10.2564 3.20051 10.3314 3.30051L11.6064 2.10051C11.7189 1.98801 11.8533 1.91613 12.0096 1.88488C12.1658 1.85363 12.3189 1.87551 12.4689 1.95051L15.3939 3.30051C15.5439 3.37551 15.6471 3.48488 15.7033 3.62863C15.7596 3.77238 15.7564 3.91301 15.6939 4.05051C15.6189 4.20051 15.5096 4.29738 15.3658 4.34113C15.2221 4.38488 15.0814 4.37551 14.9439 4.31301L12.2439 3.07551L10.4814 4.72551V5.77551L12.2439 7.38801L14.9439 6.15051C15.0814 6.08801 15.2252 6.08176 15.3752 6.13176C15.5252 6.18176 15.6314 6.27551 15.6939 6.41301C15.7689 6.56301 15.7752 6.70676 15.7127 6.84426C15.6502 6.98176 15.5439 7.08801 15.3939 7.16301L12.4689 8.55051C12.3189 8.62551 12.1658 8.64738 12.0096 8.61613C11.8533 8.58488 11.7189 8.51301 11.6064 8.40051L10.3314 7.20051C10.2564 7.27551 10.1658 7.34426 10.0596 7.40676C9.95332 7.46926 9.84395 7.50051 9.73145 7.50051C9.51895 7.50051 9.34082 7.42863 9.19707 7.28488C9.05332 7.14113 8.98145 6.96301 8.98145 6.75051V6.00051H6.58145C6.54395 6.10051 6.50332 6.19426 6.45957 6.28176C6.41582 6.36926 6.35645 6.46301 6.28145 6.56301L10.0314 13.5005H12.7314V15.7505H2.98145ZM4.48145 6.00051C4.69395 6.00051 4.87207 5.92863 5.01582 5.78488C5.15957 5.64113 5.23145 5.46301 5.23145 5.25051C5.23145 5.03801 5.15957 4.85988 5.01582 4.71613C4.87207 4.57238 4.69395 4.50051 4.48145 4.50051C4.26895 4.50051 4.09082 4.57238 3.94707 4.71613C3.80332 4.85988 3.73145 5.03801 3.73145 5.25051C3.73145 5.46301 3.80332 5.64113 3.94707 5.78488C4.09082 5.92863 4.26895 6.00051 4.48145 6.00051ZM6.84395 13.5005H8.30645L5.08145 7.50051H5.00645L6.84395 13.5005Z"
        />
      </g>
    </svg>
  )
}

export default PrecisionManufacturing
